import React, { Component } from 'react'
import { EditorBlock, ContentBlock, EditorState } from 'draft-js'
import styled, { keyframes } from 'styled-components'
import { TaskState } from '@src/editor-helpers'

type Props = {
  block: ContentBlock
  blockProps: { getEditorState: () => EditorState }
}
class ConspectBlock extends Component<Props> {
  render() {
    const { block } = this.props

    const type = block.get('data').get('type')
    return type === 'conspect' ? this.renderConspect() : this.renderSolution()
  }

  renderConspect() {
    const {
      block,
      blockProps: { getEditorState }
    } = this.props
    const editorState = getEditorState()
    const taskState = TaskState.fromEditorState(editorState)
    const currentTask = TaskState.getTaskByKey(taskState, block.get('key'))
    const isEmpty =
      TaskState.isTaskBlockEmpty(currentTask, block.get('key')) &&
      TaskState.isOnlyOneKeyInTaskBlock(currentTask, block.get('key'))

    return (
      <Conspect data-draftjs-block-key={block.get('key')} className={isEmpty ? 'empty' : ''}>
        <EditorBlock {...this.props} />
      </Conspect>
    )
  }

  renderSolution() {
    const {
      block,
      blockProps: { getEditorState }
    } = this.props

    const editorState = getEditorState()
    const taskState = TaskState.fromEditorState(editorState)
    const currentTask = TaskState.getTaskByKey(taskState, block.get('key'))
    const isEmpty =
      TaskState.isTaskBlockEmpty(currentTask, block.get('key')) &&
      TaskState.isOnlyOneKeyInTaskBlock(currentTask, block.get('key'))
    return (
      <Solution data-draftjs-block-key={block.get('key')} className={isEmpty ? 'empty' : ''}>
        <EditorBlock {...this.props} />
      </Solution>
    )
  }
}

const show = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const Conspect = styled.div`
  animation: ${show} 0.2s linear;
  position: relative;

  &.empty:after {
    content: 'Конспект. Замечания клиента';
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    color: #aba8a1;
  }
`

const Solution = styled.div`
  animation: ${show} 0.2s linear;
  position: relative;
  /* margin-top: 0.3em; */
  /* padding-bottom: ${({ theme: { paragraphPaddingBottomEm } }) => paragraphPaddingBottomEm}; */

  &:before {
    content: 'Решение:';
    padding-right: 1ex;
    float: left;
    font-weight: 600;
    display: block;
  }

  &.empty:after {
    content: 'О чём договорились с клиентом';
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 5.55em;
    color: #aba8a1;
  }
`

export default ConspectBlock



// WEBPACK FOOTER //
// ./src/components/ConspectBlock/ConspectBlock.tsx